import React from 'react';

import classes from './NavigationItems.css';
import NavigationItem from './NavigationItem/NavigationItem';

const navigationItems = (props) => {
   let page = props.pageid;

   return (
      <ul className={classes.NavigationItems}>
         <NavigationItem navclick={''} link="/" active={page === 'home'}>
            HOME
         </NavigationItem>
         <NavigationItem navclick={'about'} link="/" active={page === 'about'}>
            ABOUT
         </NavigationItem>
         <NavigationItem navclick={'services'} link="/" active={page === 'services'}>
            SERVICES
         </NavigationItem>
         <NavigationItem navclick={'location'} link="/" active={page === 'location'}>
            LOCATION
         </NavigationItem>
         <NavigationItem navclick={'gallery'} link="/" active={page === 'gallery'}>
            GALLERY
         </NavigationItem>
      </ul>
   );
};

export default navigationItems;



// WEBPACK FOOTER //
// ./src/components/Navigation/NavigationItems/NavigationItems.js